export const translations = {
  en: {
    home: "Home",
    solutions: "Solutions",
    contactUs: "Contact Us",
    title: "Your own GenAI that accompanies your employees.",
    slogan: "Make work more human",
    sloganSubtitle: "AI-powered solutions that amplify your team's potential and transform how work gets done.",
    exploreSolutions: "Explore Solutions",
    learnMore: "Learn more",
    ourProducts: "Our Products",
    productVirtualMentor: "AI Virtual Mentor",
    productVirtualMentorDesc: "Your company's internal knowledge expert. Advanced RAG-powered knowledge base built from proven enterprise practices — instant answers for every employee, 24/7.",
    productSmartFlow: "AI SmartFlow",
    productSmartFlowDesc: "Intelligent workflow automation powered by agentic systems. Replace manual judgment flows with AI-native processes that think, decide, and act.",
    productTranslide: "Translide",
    productTranslideDesc: "One-click AI translation for PowerPoint. Converts text and tables into any language while preserving your original layout and styles.",
    tryTranslide: "Try Translide",
    productTranswork: "Transwork",
    productTransworkDesc: "A desktop companion that keeps your team in flow. Eliminates context switching so your staff can focus on what matters.",
    comingSoon: "Coming Soon",
    businessScenarios: "Business scenarios",
    salesTraining: "Sales training",
    salesTrainingDesc: "Focus on the broader principles. Leave the details to AI.",
    searchingAnswers: "Searching for answers",
    searchingAnswersDesc: "Calling peers/managers for questions? Just ask AI.",
    knowledgeSharing: "Knowledge sharing",
    knowledgeSharingDesc: "Talk to AI as a seasoned employee for best practices.",
    contactDescription: "For any inquiries, please contact us at:",

    // Solutions - AI Virtual Mentor
    vmTitle: "AI Virtual Mentor",
    vmSubtitle: "Your company's 24/7 internal knowledge expert, powered by advanced RAG technology.",
    vmJobsTitle: "Jobs-to-be-done",
    vmJob1: "A real-time 24/7 knowledge expert for every sales (and other employees)",
    vmJob2: "Accurate answers/content generation based on provided source documents",
    vmJob3: "A data secure procedure that guarantees zero leakage of sensitive information",
    vmJob4: "An interactive and multi-modal user experience that enhances learning effectiveness",
    vmFeaturesTitle: "Product Features",
    vmFeature1: "Integration with real-time chat app, answer is grounded by citation",
    vmFeature2: "Can be completely private-deployed for better data protection",
    vmFeature3: "Multi-model engagement including texts, pictures, AI avatars",
    vmFeature4: "Quality-in, quality-out. Support all common type of files",
    vmUsageTitle: "Usage Scenario",
    vmUsageDesc: "Make organizational knowledge easily accessible and usable for all employees. Including",
    vmUsage1: "New employees onboarding",
    vmUsage2: "Regular training session preparation",
    vmUsage3: "Out-of-office knowledge retrieval / consultation",
    vmUsage4: "Training material creation",
    vmKBTitle: "One-stop Knowledge Base",
    vmKBDesc: "Make enterprise knowledge searchable, digestible, and contextualized",
    vmKB1: "Company policies, procedures",
    vmKB2: "Product specifications",
    vmKB3: "Best practices",
    vmKB4: "Integration with existing databases",

    // Solutions - AI SmartFlow
    sfTitle: "AI SmartFlow",
    sfSubtitle: "Intelligent workflow automation that chains specialized AI agents to identify, evaluate, and assess complex business processes end-to-end.",
    sfCapabilities: "Core Capabilities",
    sfCap1Title: "Multi-Agent Workflows",
    sfCap1Desc: "Chain specialized AI agents in sequence — each one identifies, evaluates, or assesses — replacing manual multi-step judgment processes with autonomous AI pipelines.",
    sfCap2Title: "Smart Knowledge Base",
    sfCap2Desc: "RAG-powered document management with intelligent parsing. Upload PDFs, Excel, Word, and PPT files — the system chunks, indexes, and semantically searches your enterprise knowledge.",
    sfCap3Title: "Automated Document Processing",
    sfCap3Desc: "Upload structured files like spreadsheets and templates. AI extracts data, merges sources, translates content, and produces structured outputs — no manual data entry.",
    sfCap4Title: "AI-Powered Evaluation",
    sfCap4Desc: "Automated assessment of questionnaires and compliance documents. AI evaluates responses, flags issues, and allows human override when expert judgment is needed.",
    sfCap5Title: "Structured Reports",
    sfCap5Desc: "Multi-dimensional analysis that produces clear ratings, reasoning, and recommendations. Export results as CSV, JSON, or integrate directly with your existing systems.",
    sfCap6Title: "Full Audit Trail",
    sfCap6Desc: "Complete run history with version management. Track every agent execution, review input parameters, and replay any workflow step for full transparency.",
    sfHowTitle: "How It Works",
    sfStep1Title: "Configure",
    sfStep1Desc: "Set up knowledge bases, upload documents, and define input parameters for your workflow.",
    sfStep2Title: "Identify",
    sfStep2Desc: "Read Agent extracts and identifies relevant items from multiple data sources, producing a structured list.",
    sfStep3Title: "Evaluate",
    sfStep3Desc: "Interactive Agent evaluates questionnaires and supporting materials with AI-powered assessment.",
    sfStep4Title: "Assess & Report",
    sfStep4Desc: "Work Agent performs multi-level assessment, generates risk ratings with reasoning, and outputs final structured results.",
    sfUseCases: "Use Cases",
    sfUseCase1Title: "Regulatory Compliance",
    sfUseCase1Desc: "Automate compliance checks against national standards, industry regulations, and internal policies.",
    sfUseCase2Title: "Supplier Assessment",
    sfUseCase2Desc: "Evaluate supplier questionnaires and documentation with consistent, AI-powered scoring.",
    sfUseCase3Title: "Quality Assurance",
    sfUseCase3Desc: "Multi-source data verification, risk identification, and structured assessment reporting.",

    // Solutions - Translide
    tlTitle: "Translide",
    tlSubtitle: "One-click AI translation for PowerPoint presentations. Preserve your layouts, translate your message.",
    tlFeature1Title: "Layout Preservation",
    tlFeature1Desc: "Translates text and tables while keeping your original slide design, fonts, and formatting intact.",
    tlFeature2Title: "Any Language",
    tlFeature2Desc: "Support for 50+ languages with context-aware AI translation that understands business terminology.",
    tlFeature3Title: "One Click",
    tlFeature3Desc: "Upload your .pptx, select target language, download. No complex setup or manual formatting needed.",
    tlCTA: "Try Translide",

    // Solutions - Transwork
    twTitle: "Transwork",
    twSubtitle: "A desktop companion that keeps your team in flow. Eliminates context switching so your staff can focus on what matters.",
    twFeature1Title: "Focus Mode",
    twFeature1Desc: "Intelligent notification management that batches interruptions and protects deep work sessions.",
    twFeature2Title: "Smart Context",
    twFeature2Desc: "Remembers what you were working on and seamlessly restores your workflow after interruptions.",
    twFeature3Title: "Team Sync",
    twFeature3Desc: "Lightweight status sharing so your team knows availability without disruptive check-ins.",

    contactSales: "Contact Sales",

    footerProducts: "Products",
    footerCompany: "Company",
    footerContact: "Contact",
    footer: "2026 Longway AI. All rights reserved."
  },
  zh: {
    home: "首页",
    solutions: "解决方案",
    contactUs: "联系我们",
    title: "一个完全属于您企业的GenAI，时刻陪伴您的员工。",
    slogan: "让工作更人性化",
    sloganSubtitle: "以AI赋能团队潜力，重新定义工作方式。",
    exploreSolutions: "探索解决方案",
    learnMore: "了解更多",
    ourProducts: "我们的产品",
    productVirtualMentor: "AI虚拟导师",
    productVirtualMentorDesc: "您企业的内部知识专家。基于先进RAG技术构建的企业知识库，源自经过验证的企业实践——为每位员工提供全天候即时解答。",
    productSmartFlow: "AI工作流",
    productSmartFlowDesc: "由智能体系统驱动的工作流自动化。用AI原生流程取代人工判断流程，实现自主思考、决策和执行。",
    productTranslide: "Translide",
    productTranslideDesc: "一键AI翻译PowerPoint。将文本和表格翻译为任何语言，同时保留原始版式和样式。",
    tryTranslide: "体验Translide",
    productTranswork: "Transwork",
    productTransworkDesc: "让团队保持专注的桌面助手。消除上下文切换，让员工专注于真正重要的事。",
    comingSoon: "即将推出",
    businessScenarios: "业务场景",
    salesTraining: "销售培训",
    salesTrainingDesc: "专注于更广泛的原则。将细节留给AI。",
    searchingAnswers: "寻找答案",
    searchingAnswersDesc: "需要打电话给同事/经理询问问题？直接问AI。",
    knowledgeSharing: "知识共享",
    knowledgeSharingDesc: "与AI交谈，如同与经验丰富的员工交流最佳实践。",
    contactDescription: "如有任何疑问，请通过以下方式联系我们：",

    // Solutions - AI Virtual Mentor
    vmTitle: "AI虚拟导师",
    vmSubtitle: "基于先进RAG技术，为您的企业打造全天候内部知识专家。",
    vmJobsTitle: "产品价值",
    vmJob1: "为每个销售（和其他员工）提供实时24/7知识专家",
    vmJob2: "基于提供的源文档生成准确的答案/内容",
    vmJob3: "确保敏感信息零泄露的数据安全程序",
    vmJob4: "增强学习效果的交互式多模态用户体验",
    vmFeaturesTitle: "产品优势",
    vmFeature1: "与实时聊天应用集成，答案基于引用来源",
    vmFeature2: "可完全私有部署以更好地保护数据",
    vmFeature3: "多模态交互，包括文本、图片、AI头像",
    vmFeature4: "质量输入，质量输出。支持所有常见文件类型",
    vmUsageTitle: "使用场景",
    vmUsageDesc: "使组织知识易于所有员工访问和使用。包括",
    vmUsage1: "新员工入职",
    vmUsage2: "常规培训会议准备",
    vmUsage3: "办公室外知识检索/咨询",
    vmUsage4: "培训材料创建",
    vmKBTitle: "一站式知识库",
    vmKBDesc: "使企业知识可搜索、易消化和具有上下文",
    vmKB1: "公司政策、程序",
    vmKB2: "产品规格",
    vmKB3: "最佳实践",
    vmKB4: "与现有数据库集成",

    // Solutions - AI SmartFlow
    sfTitle: "AI工作流",
    sfSubtitle: "智能工作流自动化——串联专业AI智能体，端到端完成复杂业务流程的识别、评估和审定。",
    sfCapabilities: "核心能力",
    sfCap1Title: "多智能体工作流",
    sfCap1Desc: "将专业AI智能体按序串联——分别负责识别、评估和审定——用自主AI流水线取代人工多步判断流程。",
    sfCap2Title: "智能知识库",
    sfCap2Desc: "基于RAG技术的文档管理与智能解析。上传PDF、Excel、Word和PPT文件，系统自动分块、索引并语义检索企业知识。",
    sfCap3Title: "自动化文档处理",
    sfCap3Desc: "上传电子表格和模板等结构化文件，AI自动提取数据、合并来源、翻译内容并生成结构化输出——无需手动录入。",
    sfCap4Title: "AI驱动的评估",
    sfCap4Desc: "自动评估问卷和合规文档。AI评判回答、标记问题，并在需要专家判断时支持人工覆盖。",
    sfCap5Title: "结构化报告",
    sfCap5Desc: "多维度分析，输出清晰的评级、推理依据和建议。支持导出CSV、JSON，或直接与现有系统集成。",
    sfCap6Title: "完整审计追踪",
    sfCap6Desc: "完整的运行历史与版本管理。追踪每次智能体执行，回溯输入参数，重放任意工作流步骤，确保全流程透明可查。",
    sfHowTitle: "工作流程",
    sfStep1Title: "配置",
    sfStep1Desc: "创建知识库、上传文档，定义工作流的输入参数。",
    sfStep2Title: "识别",
    sfStep2Desc: "阅读智能体从多个数据源提取并识别相关条目，生成结构化列表。",
    sfStep3Title: "评估",
    sfStep3Desc: "交互智能体对问卷和支持材料进行AI驱动的自动评估。",
    sfStep4Title: "审定与报告",
    sfStep4Desc: "工作智能体执行多层级审定，生成带有推理依据的评级结果，输出最终结构化报告。",
    sfUseCases: "应用场景",
    sfUseCase1Title: "法规合规",
    sfUseCase1Desc: "自动化对照国家标准、行业法规和企业内部政策的合规检查。",
    sfUseCase2Title: "供应商评估",
    sfUseCase2Desc: "用一致的AI驱动评分体系评估供应商问卷和文档资料。",
    sfUseCase3Title: "质量保证",
    sfUseCase3Desc: "多源数据验证、风险识别及结构化评估报告生成。",

    // Solutions - Translide
    tlTitle: "Translide",
    tlSubtitle: "一键AI翻译PowerPoint演示文稿。保留版式，传递信息。",
    tlFeature1Title: "版式保留",
    tlFeature1Desc: "翻译文本和表格的同时，保持原始幻灯片设计、字体和格式不变。",
    tlFeature2Title: "任意语言",
    tlFeature2Desc: "支持50+语言，AI翻译理解上下文和商业术语。",
    tlFeature3Title: "一键完成",
    tlFeature3Desc: "上传.pptx文件，选择目标语言，下载。无需复杂设置或手动排版。",
    tlCTA: "体验Translide",

    // Solutions - Transwork
    twTitle: "Transwork",
    twSubtitle: "让团队保持专注的桌面助手。消除上下文切换，让员工专注于真正重要的事。",
    twFeature1Title: "专注模式",
    twFeature1Desc: "智能通知管理，批量处理打断，保护深度工作时间。",
    twFeature2Title: "智能上下文",
    twFeature2Desc: "记住你的工作状态，中断后无缝恢复工作流。",
    twFeature3Title: "团队同步",
    twFeature3Desc: "轻量级状态共享，团队成员无需频繁打扰即可了解彼此状态。",

    contactSales: "联系销售",

    footerProducts: "产品",
    footerCompany: "公司",
    footerContact: "联系方式",
    footer: "2026 朗唯九道（上海）科技有限公司。版权所有。"
  }
};
